/**
 * <pdp-media> — custom gallery: thumbnails, arrows, external video, setActiveMedia() for product-info.
 */
(function () {
  if (customElements.get('pdp-media')) return;

  class PdpMedia extends HTMLElement {
    connectedCallback() {
      if (this.dataset.pdpInit === 'true') return;
      this.dataset.pdpInit = 'true';
      this.querySelector('.pdp-media__nav-btn--prev')?.addEventListener('click', () => this.#step(-1));
      this.querySelector('.pdp-media__nav-btn--next')?.addEventListener('click', () => this.#step(1));
      this.addEventListener('click', this.#onThumbClick);
      this.querySelectorAll('.pdp-media__external[data-external-video]').forEach((el) => {
        el.querySelector('.pdp-media__play')?.addEventListener('click', () => this.#loadExternalIframe(el));
      });
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.#onThumbClick);
    }

    #onThumbClick = (e) => {
      const btn = e.target.closest('.pdp-media__thumb');
      if (!btn || !this.contains(btn)) return;
      const id = btn.getAttribute('data-media-ref');
      if (id) this.setActiveMedia(id, false);
    };

    #getSlides() {
      return Array.from(this.querySelectorAll('.pdp-media__slide[data-media-id]'));
    }

    #step(dir) {
      const slides = this.#getSlides();
      if (slides.length < 2) return;
      const idx = slides.findIndex((el) => el.classList.contains('is-active'));
      if (idx === -1) return;
      const nextIdx = (idx + dir + slides.length) % slides.length;
      const id = slides[nextIdx].dataset.mediaId;
      if (id) this.setActiveMedia(id, false);
    }

    #loadExternalIframe(wrap) {
      if (wrap.dataset.loaded === 'true') return;
      const tpl = wrap.querySelector('template');
      if (!tpl) return;
      wrap.dataset.loaded = 'true';
      wrap.querySelector('.pdp-media__poster')?.remove();
      wrap.querySelector('.pdp-media__play')?.remove();
      wrap.appendChild(tpl.content.cloneNode(true));
      tpl.remove();
    }

    #pauseInactiveSlides() {
      const isGridDesktop =
        this.classList.contains('pdp-media--grid') &&
        typeof window.matchMedia === 'function' &&
        window.matchMedia('(min-width: 767px)').matches;
      if (isGridDesktop) return;
      this.querySelectorAll('.pdp-media__slide:not(.is-active) video').forEach((v) => {
        try {
          v.pause();
        } catch (_) {}
      });
    }

    setActiveMedia(mediaId, prepend) {
      const slidesRoot = this.querySelector('.pdp-media__slides');
      const thumbsRoot = this.querySelector('.pdp-media__thumb-list');
      if (!slidesRoot) return;

      let active = slidesRoot.querySelector(`.pdp-media__slide[data-media-id="${mediaId}"]`);
      if (!active) active = slidesRoot.querySelector('.pdp-media__slide[data-media-id]');
      if (!active) return;

      if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
      this.#pauseInactiveSlides();

      slidesRoot.querySelectorAll('.pdp-media__slide').forEach((el) => el.classList.remove('is-active'));
      active.classList.add('is-active');

      if (prepend && active.parentElement && slidesRoot.firstChild !== active) {
        slidesRoot.prepend(active);
        const thumb = thumbsRoot?.querySelector(`[data-media-ref="${mediaId}"]`);
        const thumbLi = thumb?.closest('.pdp-media__thumb-item');
        if (thumbLi && thumbsRoot && thumbsRoot.firstChild !== thumbLi) {
          thumbsRoot.prepend(thumbLi);
        }
      }

      thumbsRoot?.querySelectorAll('.pdp-media__thumb').forEach((b) => {
        b.classList.remove('pdp-media__thumb--current');
        b.setAttribute('aria-current', 'false');
      });
      const curThumb = thumbsRoot?.querySelector(`[data-media-ref="${mediaId}"]`);
      if (curThumb) {
        curThumb.classList.add('pdp-media__thumb--current');
        curThumb.setAttribute('aria-current', 'true');
        try {
          curThumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        } catch (_) {}
      }

      const status = this.querySelector('[id^="PdpMediaStatus"]');
      const img = active.querySelector('.pdp-media__img');
      if (status && img?.alt) status.textContent = img.alt;

      const video = active.querySelector('.pdp-media__video-box video');
      if (video) {
        try {
          video.play();
        } catch (_) {}
      }
    }
  }

  customElements.define('pdp-media', PdpMedia);
})();
